import styles from "./Receipt.module.scss";
import logoDark from "assets/icons/logoDark.svg";
import classNames from "classnames";
import { BillPaymentType } from "types/transaction";
import { formatDate } from "utils/formatter";

interface ReceiptType {
  transaction: BillPaymentType;
}

const Receipt = ({ transaction }: ReceiptType) => {

  // useEffect(() => {
  //   if (transaction?.amount) calculateFlutterCharge(transaction.amount);
  // }, [transaction, calculateFlutterCharge]);

  return (
    <>
      <div className={styles.transactionDetails}>
        <div className={styles.center}>
          <img src={logoDark} alt="pawa360" className={styles.logo} />
          <p>
          {transaction?.createdAt &&
            formatDate({ val: transaction?.createdAt, fullDate: true })}
        </p>
        </div>
        {transaction?.meterType?.toLocaleLowerCase() === "prepaid" && (
          <div className={styles.token}>
            <h3>
              {transaction?.token
                ? transaction?.token
                : " No token generated. Please, contact Support."}
            </h3>
          </div>
        )}
        {transaction?.meterType?.toLocaleLowerCase() === "postpaid" && (
          <div className={styles.token}>
            <h5 style={{ fontSize: "14px" }}>
              Outstanding Debt: {transaction?.currency}{" "}
              {transaction?.outstandingDebt
                ? transaction?.outstandingDebt
                : "0.00"}
            </h5>
          </div>
        )}
        <div className={classNames([styles.item])}>
          <div className={classNames([styles.flexItem, styles.margin10])}>
            <p className={styles.title}>Customer Name</p>
            <p className={styles.text}>{transaction?.customerName}</p>
          </div>
          <div className={classNames([styles.flexItem])}>
            <p className={styles.title}>Address</p>
            <p className={styles.text}>{transaction?.customerAddress}</p>
          </div>
        </div>
        <div className={classNames([styles.flexRow, styles.item])}>
          <p className={styles.title}>Meter Number</p>
          <p className={styles.text}>{transaction?.meterNumber}</p>
        </div>
        <div className={classNames([styles.item])}>
          {transaction?.meterType?.toLocaleLowerCase() === "prepaid" && (
            <div className={classNames([styles.flexRow])}>
              <p className={styles.title}>Unit value</p>
              <p className={styles.text}>
                {transaction?.units && transaction?.units} units
              </p>
            </div>
          )}
          <div className={classNames([styles.flexRow])}>
            <p className={styles.title}>Electricity Amount</p>
            <p className={styles.text}>
              {transaction?.currency}{" "}
              {transaction?.billPurchaseAmount &&
                transaction?.billPurchaseAmount}
            </p>
          </div>
          {/* <div className={classNames([styles.flexRow])}>
            <p className={styles.title}>VAT</p>
            <p className={styles.text}>
              {transaction?.currency}{" "}
              {transaction?.vatChargeAmount}
            </p>
          </div> */}
          <div className={classNames([styles.flexRow])}>
            <p className={styles.title}>Service charge</p>
            <p className={styles.text}>
              {transaction?.currency}{" "}
              {parseFloat(transaction?.serviceChargeAmount) +
                parseFloat(transaction?.providerChargeAmount)}
            </p>
          </div>
          <div className={classNames([styles.flexRow])}>
            <p className={styles.title}>Total</p>
            <p className={styles.text}>
              {transaction?.currency} {transaction?.totalAmount}
            </p>
          </div>
        </div>

        <div className={classNames([styles.flexRow])}>
          <p className={styles.title}>Operator</p>
          <p className={styles.text}>Pawa360</p>
        </div>
        <p className={styles.bottomText}>Thank you for your purchase.</p>
        <div className={styles.center}>
          <img src={logoDark} alt="pawa360" className={styles.logo} />
        </div>
      </div>
      {/* <div className={styles.btnContainer}>
        <Button text="Send to Email" color="dark" disabled />
        <Button text="Download" color="dark" />
      </div> */}
    </>
  );
};

export default Receipt;
